import { render, staticRenderFns } from "./ScormPlayer.vue?vue&type=template&id=4a918e36&scoped=true"
import script from "./ScormPlayer.vue?vue&type=script&lang=js"
export * from "./ScormPlayer.vue?vue&type=script&lang=js"
import style0 from "./ScormPlayer.vue?vue&type=style&index=0&id=4a918e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a918e36",
  null
  
)

export default component.exports